module.exports = __webpack_public_path__ + "img/2_1-parco-1.35bf378b.png";